"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueService = void 0;
const routes_1 = require("./routes");
class QueueService {
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    async createQueue(data, authToken) {
        const result = await this.axiosInstance.post(routes_1.createQueueRoute, data, {
            headers: { Authorization: 'Bearer ' + authToken },
        });
        return result.data;
    }
    async getNextQueue(data) {
        const result = await this.axiosInstance.post(routes_1.getNextQueueRoute, data);
        return result.data;
    }
    async getOneById(id) {
        const result = await this.axiosInstance.get(routes_1.getOneRoute + id);
        return result.data;
    }
    async getOneByIdV2(id) {
        const result = await this.axiosInstance.get(routes_1.getOneRoute + id);
        return result;
    }
    async findOneByCode(code) {
        const result = await this.axiosInstance.get(routes_1.getOneRoute + code + '/findByCode');
        return result.data;
    }
    async delete(id, ownerToken) {
        const result = await this.axiosInstance.delete(routes_1.getOneRoute + id, {
            headers: { Authorization: 'Bearer ' + ownerToken },
        });
        return result.data;
    }
    async reset(id, ownerToken) {
        const result = await this.axiosInstance.patch(routes_1.getOneRoute + id + '/reset', null, {
            headers: { Authorization: 'Bearer ' + ownerToken },
        });
        return result.data;
    }
    async createTicket(id, data) {
        const result = await this.axiosInstance.post(routes_1.getOneRoute + id + '/ticket', data);
        return result.data;
    }
    async shift(id, previousState, table) {
        const result = await this.axiosInstance.patch(routes_1.getOneRoute + id + '/shift/' + previousState + '/' + table);
        return result.data;
    }
    async undo(id, table) {
        const result = await this.axiosInstance.patch(routes_1.getOneRoute + id + '/undo/' + table);
        return result.data;
    }
}
exports.QueueService = QueueService;
//# sourceMappingURL=index.js.map